export const SET_COUNTER = 'SET_COUNTER';
export const INCREMENT_COUNTER = 'INCREMENT_COUNTER';
export const INCREMENT_COUNTER_BY = 'INCREMENT_COUNTER_BY';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

